import { MATCH_PLAY_FORMATS, STROKE_PLAY_FORMATS } from '@/constants/golfFormats'

/**
 * Function to check if a golf tournament is a StrokePlay tournament based on the format given.
 *
 * There are several different types of golf formats and each format sits under one of the two main types of golf tournaments, either MatchPlay or StrokePlay.
 * This function takes the format from a tournament object and checks to see if is included within the formats of StrokePlay golf tournaments.
 *
 * @param {string} format - A string param
 * @return {boolean} True if the format is included in the values of StrokePlay tournaments
 *
 */
export const isStrokePlay = (format: string) => STROKE_PLAY_FORMATS.includes(format)

/**
 * Function to check if a golf tournament is a MatchPlay tournament based on the format given.
 *
 * There are several different types of golf formats and each format sits under one of the two main types of golf tournaments, either MatchPlay or StrokePlay.
 * This function takes the format from a tournament object and checks to see if is included within the formats of MatchPlay golf tournaments.
 *
 * @param {string} format - A string param
 * @return {boolean} True if the format is included in the values of MatchPlay tournaments
 *
 */
export const isMatchPlay = (format: string) => MATCH_PLAY_FORMATS.includes(format)
